<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="width: 200px"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1152px;">
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="business_name" label="Business Name" width="180"></el-table-column>
      <el-table-column prop="amount" label="Amount" width="150"></el-table-column>
      <el-table-column prop="country" label="Country" width="120"></el-table-column>
      <el-table-column prop="system_name" label="System Name" width="160"></el-table-column>
      <el-table-column prop="save_time" label="Save Time" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.save_time | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit / Add 弹窗 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="150px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Country/Business" prop="business_name">
          <el-cascader :options="country_business" size="small"
            :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
            placeholder="Country/Business" v-model="editForm.cascaderValue" @change="editCascaderChange"
            style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input size="small" v-model="editForm.amount" placeholder="Rate diff amount" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  exchangeRateDiffList,
  exchangeRateDiffSave,
  exchangeRateDiffDelete,
  getCountryBusiness,
} from '../../api/apiFun'
import {
  timestampToTime,
  cascaderChange,
} from '@/utils/util'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      title: 'Add',
      editForm: {
        id: '',
        cascaderValue: [],
        country: '',
        business_name: '',
        business_id: '',
        amount: '',
      },
      rules: {
        business_name: [{
          required: true,
          message: 'Please select country/business',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: 'Please enter the amount',
          trigger: 'blur'
        }],
      },
      params: {
        page: 1,
        limit: 10,
        country: '',
        business_name: '',
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      country_business: [],
    }
  },
  components: {
    Pagination
  },
  filters: {
    timestampToTime(timestamp) {
      return timestampToTime(timestamp)
    }
  },
  created() {
    this.getdata(this.params)
    this.getCountryBusiness()
  },
  methods: {
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.country_business = res.datas
        }
      }).catch(() => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    cascaderChange(value) {
      var result = cascaderChange(value)
      this.params.country = result[0] || ''
      this.params.business_name = result[1] || ''
    },
    editCascaderChange(value) {
      var result = cascaderChange(value)
      this.editForm.country = result[0] || ''
      this.editForm.business_name = result[1] || result[0] || ''
    },
    getdata(parameter) {
      this.loading = true
      exchangeRateDiffList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.listData = res.datas.list
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('Failed to get list, please try again later!')
      })
    },
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
    handleEdit(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.id = row.id
        this.editForm.country = row.country || ''
        this.editForm.business_name = row.business_name
        this.editForm.business_id = row.business_id
        this.editForm.amount = row.amount
        this.editForm.cascaderValue = row.country
          ? [row.country, row.business_name]
          : [row.country]
      } else {
        this.title = 'Add'
        this.editForm.id = ''
        this.editForm.cascaderValue = []
        this.editForm.country = ''
        this.editForm.business_name = ''
        this.editForm.business_id = ''
        this.editForm.amount = ''
      }
    },
    submitForm(editData) {
      this.loading = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          exchangeRateDiffSave(this.editForm).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({ type: 'success', message: 'Saved successfully!' })
            } else {
              this.$message({ type: 'info', message: res.msg })
            }
          }).catch(() => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('Save failed, please try again later!')
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    handleDelete(index, row) {
      this.$confirm('Are you sure to delete this record?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        exchangeRateDiffDelete({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.listData.splice(index, 1)
            this.$message({ type: 'success', message: 'Deleted successfully!' })
          } else {
            this.$message({ type: 'info', message: res.msg })
          }
        }).catch(() => {
          this.$message.error('Delete failed, please try again later!')
        })
      }).catch(() => { })
    },
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/business_settlement/exchange_rate_diff.vue